import React, { Component } from 'react';
import 'fullcalendar/dist/fullcalendar.css';
//import 'fullcalendar/dist/fullcalendar.print.min.css';
import 'fullcalendar/dist/fullcalendar.js';
import '../resources/css/VenueStatsBar.css';
import {firebaseDb} from '../lib/firebase/firebase';
import { 
  Carousel,
} from 'react-bootstrap/lib';
class BarPanel extends Component {
  render(){
    return (
      <div className="stats-bar-panel col-md-3">
        <div className="panel pael-default">
          <div className="panel-body">
            <div className="row">
              <div className="col-md-12">
                <h3>
                  <span className={"text-capitalize glyphicon glyphicon-"+this.props.icon} aria-hidden="true"></span>
                  <span className="text-primary text-capitalize"> {this.props.name}</span>
                </h3>
              </div>          
              <div className="col-md-12">
                <h1 className="text-primary text-right">{this.props.value}</h1>
              </div>          
              <div className="col-md-12">
                <h6 className="text-right"><span className="text-info">{this.props.secondaryValue}</span> {this.props.subText}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
class VenueStatsBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      venue:this.props.venue,
    };
  }

  componentDidMount(){
    var _self = this;
    if(!this.props.venue && this.props.venueId){
      firebaseDb.ref("venues/"+this.props.venueId).once('value',function(snap){
        if(snap.exists()){
          _self.setState({venue:snap.val()})
        }else{

        }
      })
    }
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.venue){
      this.setState({venue:nextProps.venue});
    }else if(nextProps.venueId && this.props.venueId!=nextProps.venueId){
      var _self = this;
      firebaseDb.ref("venues/"+this.props.venueId).once('value',function(snap){
        if(snap.exists()){
          _self.setState({venue:snap.val()})
        }else{
          //
        }
      })
    }
  }

  render() {
    if(this.state.venue){
      return (

        <div>
          <div className="row hidden-lg hidden-md">
            <Carousel
              controls={false}
              interval={3000}>
              <Carousel.Item>
                <BarPanel
                  value={12}
                  secondaryValue={2}
                  subText="made this week" 
                  name="reservations"
                  icon="calendar"/>                
              </Carousel.Item>
              <Carousel.Item>
                <BarPanel
                  value={12}
                  secondaryValue={2}
                  subText="sold this week" 
                  name="sales"
                  icon="usd"/>
              </Carousel.Item>
              <Carousel.Item>
                <BarPanel
                  value={12}
                  secondaryValue={2}
                  subText="recived this week" 
                  name="visits"
                  icon="globe"/>
              </Carousel.Item>
              <Carousel.Item>
              <BarPanel
                value={12}
                secondaryValue={2}
                subText="registered this week" 
                name="clients"
                icon="user"/>
              </Carousel.Item>
            </Carousel>
          </div>
          <div className="row hidden-sm hidden-xs">
            <BarPanel
              value={12}
              secondaryValue={2}
              subText="made this week" 
              name="reservations"
              icon="calendar"/>
            <BarPanel
              value={12}
              secondaryValue={2}
              subText="sold this week" 
              name="sales"
              icon="usd"/>
            <BarPanel
              value={12}
              secondaryValue={2}
              subText="recived this week" 
              name="visits"
              icon="globe"/>
            <BarPanel
              value={12}
              secondaryValue={2}
              subText="registered this week" 
              name="clients"
              icon="user"/>
          </div>
        </div>

      );
    }else{
      return (
        <div className="row">
          <div className="col-md-12">
            <h2>Loading...</h2>
          </div>          
        </div>
      );
    }
  }
}

export default VenueStatsBar;


// WEBPACK FOOTER //
// ./src/components/VenueStatsBar.js